import { AsCsChargeType, AsCsProcessType, AsCsReceiptStatus, AsCsReceiptType } from '../types/aiAgent/asCs';

export const AS_CS_RECEIPT_STATUS_ALL = 'ALL' as const;

export const AS_CS_RECEIPT_STATUS_LABELS: Record<AsCsReceiptStatus, string> = {
  [AsCsReceiptStatus.REQUEST]: '접수완료',
  [AsCsReceiptStatus.INPROGRESS]: '진행중',
  [AsCsReceiptStatus.COMPLETE]: '작업완료',
  [AsCsReceiptStatus.CANCEL]: '취소',
};

export const AS_CS_RECEIPT_STATUS_OPTIONS = [
  {
    value: AsCsReceiptStatus.REQUEST,
    label: AS_CS_RECEIPT_STATUS_LABELS.REQUEST,
  },
  {
    value: AsCsReceiptStatus.INPROGRESS,
    label: AS_CS_RECEIPT_STATUS_LABELS.INPROGRESS,
  },
  {
    value: AsCsReceiptStatus.COMPLETE,
    label: AS_CS_RECEIPT_STATUS_LABELS.COMPLETE,
  },
  {
    value: AsCsReceiptStatus.CANCEL,
    label: AS_CS_RECEIPT_STATUS_LABELS.CANCEL,
  },
] as const;

export const AS_CS_RECEIPT_STATUS_FILTER_OPTIONS = [
  {
    value: AS_CS_RECEIPT_STATUS_ALL,
    label: '전체',
  },
  ...AS_CS_RECEIPT_STATUS_OPTIONS,
] as const;

export const AS_CS_PROCESS_TYPE_LABELS: Record<AsCsProcessType, string> = {
  [AsCsProcessType.REPLACE]: '교체',
  [AsCsProcessType.REPAIR]: '수리',
  [AsCsProcessType.CHECK]: '점검',
  [AsCsProcessType.ETC]: '기타',
};
export const AS_CS_PROCESS_TYPE_OPTIONS = [
  {
    value: AsCsProcessType.REPLACE,
    label: AS_CS_PROCESS_TYPE_LABELS[AsCsProcessType.REPLACE],
  },
  {
    value: AsCsProcessType.REPAIR,
    label: AS_CS_PROCESS_TYPE_LABELS[AsCsProcessType.REPAIR],
  },
  {
    value: AsCsProcessType.CHECK,
    label: AS_CS_PROCESS_TYPE_LABELS[AsCsProcessType.CHECK],
  },
  {
    value: AsCsProcessType.ETC,
    label: AS_CS_PROCESS_TYPE_LABELS[AsCsProcessType.ETC],
  },
] as const;

export const AS_CS_CHARGE_TYPE_LABELS: Record<AsCsChargeType, string> = {
  [AsCsChargeType.PAID]: '유상',
  [AsCsChargeType.FREE]: '무상',
};

export const AS_CS_RECEIPT_TYPE_LABELS = {
  [AsCsReceiptType.VISIT]: '방문',
  [AsCsReceiptType.EMAIL]: '이메일',
  [AsCsReceiptType.ETC]: '기타',
  [AsCsReceiptType.CALL]: '통화',
} as const;
